const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();


function videoControl(action,target){
  var $playerWindow = $(target)[0].contentWindow;
  $playerWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
}


// ------------------------------------------------------------------------
// moviePlay
// ----- BOTH
// ------------------------------------------------------------------------
const moviePlay = () => {
  if($('.movie-wrapper').length){
    let trg = 0;
    $(window).on("load", function() {
      videoControl("playVideo",'#youtube-player');
    });
    $('.movie-wrapper, .st-Modal .close').on('click', function() {
      $(".st-Modal").toggleClass("open");
      if(trg == 0) {
        videoControl("pauseVideo",'#youtube-player');
        videoControl("playVideo",'#youtube-modal');
        trg = 1;
      } else if(trg == 1) {
        videoControl("playVideo",'#youtube-player');
        videoControl("stopVideo",'#youtube-modal');
        trg = 0;
      }
    });
  }
};



// ------------------------------------------------------------------------
// tabletFlag
// ----- BOTH
// ------------------------------------------------------------------------
const tabletFlag = () => {
  $(window).on("load", function(){
    if (/iPad|Macintosh/i.test(navigator.userAgent)&& 'ontouchend' in document || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') == -1)) {
      if(window.innerHeight > window.innerWidth) {
        $(".st-Modal").addClass("tablet");
        $(".st-Loading").addClass("tablet");
        $(".st-Firstview").addClass("tablet");
      }
    }
  });
};

// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};

// ------------------------------------------------------------------------
// toggleMenu
// ----- BOTH
// ------------------------------------------------------------------------
const toggleMenu = () => {
  $('.st-Header .fixed .hamburger button').on('click', function() {
    $(".st-Header .fixed .hamburger button").toggleClass("open");
    $(".st-Header .fixed .hamburger").toggleClass("open");
    $(".st-Header .fixed .fixed-body").toggleClass("open");
    $(".st-Header .logo").toggleClass("open");
  });
};

// ------------------------------------------------------------------------
// mvSlider
// ----- BOTH
// ------------------------------------------------------------------------
const mvSlider = () => {
  let slidenumber = $('#mvslide-main').data('is');
  let dragSize = (windowWidth/768) * 64;
  var slideMain = new Swiper('#mvslide-main', {
      parallax: true,
      resistanceRatio: 0,
      speed: 200,
      initialSlide: slidenumber,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
      draggable: true,
      dragSize: dragSize
    },
  });
  var slideSub = new Swiper('#mvslide-sub', {
    resistanceRatio: 0,
    effect: 'fade',
    initialSlide: slidenumber,
    // allowTouchMove: false,
  });
  slideMain.on('slideChange', function () {
    let idx = slideMain.realIndex;
    $('.scrollbar-label').each(function(index, e){
      if(index == idx) {
        $(e).addClass('current');
      } else {
        $(e).removeClass('current');
      }
    })
  });
  slideMain.controller.control = slideSub;
  slideSub.controller.control = slideMain;
};



// ------------------------------------------------------------------------
// loadingClose
// ----- BOTH
// ------------------------------------------------------------------------
const loadingClose = () => {
  $(window).on("load", function(){
    $(".st-Loading").addClass("change");
    $(".st-Firstview").addClass("change");
    $(".st-Container").removeClass("hidden");
    setTimeout(function(){
      $(".st-Loading").addClass("close");
      $(".st-Firstview").addClass("close");
      $(".st-Container").removeClass("fixed");
      mvSlider();
      setTimeout(function(){
        $(".st-Loading").remove();
        $(".st-Firstview").remove();
        mvSlider();
      }, 2000);
    }, 3000);
  });
};



// ------------------------------------------------------------------------
// loadingCloseAnv
// ----- BOTH
// ------------------------------------------------------------------------
const loadingCloseAnv = () => {
  $(window).on("load", function(){
    $(".st-Loading").addClass("change");
    $(".st-Firstview").addClass("change");
    $(".st-Container").removeClass("hidden");
  });
  $('.st-Firstview .button-close').on('click', function() {
    $(".st-Loading").addClass("close");
    $(".st-Firstview").addClass("close");
    $(".st-Container").removeClass("fixed");
    mvSlider();
    setTimeout(function(){
      $(".st-Loading").remove();
      $(".st-Firstview").remove();
      mvSlider();
    }, 2000);
  });
};



// ------------------------------------------------------------------------
// paraNormal
// ----- BOTH
// ------------------------------------------------------------------------
const paraNormal = () => {
  $(window).on('load', function(){
    var contHeight = $(".st-Container").outerHeight();
    var scrollHeightL = "";
    var scrollHeightS = "";
    if (/iPad|Macintosh/i.test(navigator.userAgent)&& 'ontouchend' in document) {
      $(".sw-Particles").addClass("ipad");
    }
    if (matchMedia('(max-width: 798px)').matches) {
      var scrollHeightL = (contHeight / 500) * 75;
      var scrollHeightS = (contHeight / 500) * 50;
    } else {
      var scrollHeightL = (contHeight / 500) * 105;
      var scrollHeightS = (contHeight / 500) * 65;
    }
    $(".sw-Particles").addClass("visible");
    var controller = new ScrollMagic.Controller({vertical: true});
    var tween = new TimelineMax()
      .add([
            TweenMax.to(".sw-Particles span.particles-01", 1, {backgroundPosition: "center -="+scrollHeightL+"px"}),
            TweenMax.to(".sw-Particles span.particles-02", 1, {backgroundPosition: "center -="+scrollHeightS+"px"}),
        ]);
    var scene = new ScrollMagic.Scene({triggerElement: "body", duration: contHeight, offset: 0})
      .setTween(tween)
      .addTo(controller);
  });
};



// ------------------------------------------------------------------------
// paraStory
// ----- BOTH
// ------------------------------------------------------------------------
const paraStory = () => {
  $(window).on('load', function(){
    var contHeight = $(".st-Container").outerHeight();
    var scrollHeight = (contHeight / 1000) * -7;
    var controller = new ScrollMagic.Controller({vertical: true});
    var tween = new TimelineMax()
      .add([
            TweenMax.to(".str-Mainvisual .deco span.particles-01", 1, {y: "-5%"}),
            TweenMax.to(".str-Mainvisual .deco span.particles-02", 1, {y: "-10%"}),
            TweenMax.to(".str-Mainvisual_Inner .deco-inner span.particles-front", 1, {y: "-20%"}),
            TweenMax.to(".str-Detail_Inner .deco span.particles-03", 1, {y: "-30%"}),
            TweenMax.to(".str-Detail_Inner .deco span.particles-04", 1, {y: "-20%"}),
        ]);
    var scene = new ScrollMagic.Scene({triggerElement: "body", duration: contHeight, offset: 0})
      .setTween(tween)
      .addTo(controller);
  });
};



// ------------------------------------------------------------------------
// msgStory
// ----- BOTH
// ------------------------------------------------------------------------
const msgStory = () => {
  $(window).on('load', function(){
    var contHeight = $(".st-Container").outerHeight();
    var scrollHeight = (contHeight / 1000) * -7;
    var controller = new ScrollMagic.Controller({vertical: true});
    var tween = new TimelineMax()
      .add([
            TweenMax.to(".msg-Body .deco svg", 1, {y: "-50%"}),
        ]);
    var scene = new ScrollMagic.Scene({triggerElement: "body", duration: contHeight, offset: 0})
      .setTween(tween)
      .addTo(controller);
  });
};



// ------------------------------------------------------------------------
// letterSplit
// ----- BOTH
// ------------------------------------------------------------------------
function spanWrap(tg) {
  const target = document.querySelector(tg);
  const nodes = target.childNodes;
  let convert = [];
  for (let node of nodes) {
    if (node.nodeType == 3) {//テキストの場合
      let text = node.textContent.replace(/\s+/g, '');
      text.split('').forEach((v) => {
        convert.push("<span>" + v + "</span>");
      });
    } else {
      convert.push(node.outerHTML);
    }
  }
  target.innerHTML = convert.join("");
}

const letterSplit = () => {
  $(window).on('load', function(){
    spanWrap('.split-target_catch');
    spanWrap('.split-target');
  });
};



// ------------------------------------------------------------------------
// scrollAnim
// ----- BOTH
// ------------------------------------------------------------------------
const scrollAnim = () => {
  $(window).on('scroll load', function() {
    $('.js-sc').each(function() {
      let targetPos = $(this).offset().top;
      let scrollPos = $(window).scrollTop();
      let windowHeight = $(window).height();
      if (scrollPos > targetPos - windowHeight + windowHeight / 4) {
        $(this).addClass("animated")
      }
    });
  });
};



// ------------------------------------------------------------------------
// loadAnim
// ----- BOTH
// ------------------------------------------------------------------------
const loadAnim = () => {
  $(window).on('load', function() {
    $('.js-ld').each(function() {
      const target = $(this);
      $(this).addClass("animated");
      setTimeout(function(){
        $(target).removeClass(" js-ld")
      },400);
    });
  });
};



// ------------------------------------------------------------------------
// preImage
// ----- BOTH
// ------------------------------------------------------------------------
const preImage = () => {
  $(window).on('load', function() {
    $(".lower").addClass("visible");
  });
};


// ------------------------------------------------------------------------
// animParticle
// ----- BOTH
// ------------------------------------------------------------------------
const animParticle = () => {
  // PIXI.settings.CAN_UPLOAD_SAME_BUFFER = false;
  const animParticles = (target,img) => {
    var elm   = document.getElementById(target);
    var elmHeight = elm.clientHeight;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var mouse = {x:0,y:0};
    var exTrg = 0;
    var exEndTrg = 0;
    let beforePos = 0;
    const app = new PIXI.Application({width: windowWidth, height: windowHeight, transparent: true});
    app.stage.interactive = true;
    elm.appendChild(app.view);

    const sprites = new PIXI.ParticleContainer(100, {
        scale: true,
        position: true,
        alpha: true,
        autoResize: true,
        rotation: true,
    });

    // sprites.filterArea = new PIXI.Rectangle(0,0,2000,2000);
    // let blur = new PIXI.filters.BlurFilter();
    // sprites.filters = [blur];
    app.stage.addChild(sprites);

    const particles = [];
    let spritesValue = '';
    if (matchMedia('(max-width: 798px)').matches) {
      spritesValue = 50;
    } else {
      spritesValue = 100;
    }

    const totalSprites = app.renderer instanceof PIXI.Renderer ? spritesValue : spritesValue;


    const alphaflags = [];
    let alphaflag;
    const scaleflags = [];
    let scaleflag;
    for (let i = 0; i < totalSprites; i++) {
        // create a new Sprite
        let particle = PIXI.Sprite.from(img);

        particle.tint = 0xb5f4ff;
        // var tl = new TimelineMax({ repeat: -1, yoyo: true })
        //   .to(particle, 1, { pixi: { tint: 0xb5f4ff }})
        //   .to(particle, 1, { pixi: { tint: 0xffb5d6 }});
        particle.anchor.set(0.5);

        if(windowWidth > 768) {
          particle.scale.set(0.1 + Math.random() * 0.1);
        } else {
          particle.scale.set(0.1 + Math.random() * 0.1);
        }

        particle.x = Math.random() * app.screen.width;
        particle.y = Math.random() * app.screen.height;

        particle.direction = Math.random() * Math.PI * 2;

        particle.turningSpeed = Math.random() - 0.8;

        particle.speed = (2 + Math.random() * 2) * 0.5;

        particle.offset = Math.random() * 100;
        particle.alpha = Math.random() * 0.4;


        particles.push(particle);

        sprites.addChild(particle);

        let alphaflag = 2;
        let scaleflag = 2;


        alphaflags.push(alphaflag);
        scaleflags.push(scaleflag);



    }
    function onPointerMove(e) {
        mouse.x = e.data.global.x;
        mouse.y = e.data.global.y;
    }

    app.stage
      .on('mousemove', onPointerMove)
      .on('touchmove', onPointerMove);

    const particleBoundsPadding = 100;
    let particleBounds = new PIXI.Rectangle(
        -particleBoundsPadding,
        -particleBoundsPadding,
        app.screen.width + particleBoundsPadding * 2,
        app.screen.height + particleBoundsPadding * 2,
    );

    let tick = 0;
    let count = 0;
    app.ticker.add(() => {
        for (let i = 0; i < particles.length; i++) {
            const particle = particles[i];

            // particle.filters = [new PIXI.filters.BlurFilter(5)]

            particle.direction += particle.turningSpeed * 0.01;
            particle.x += Math.sin(particle.direction) * 0.5;
            particle.y += Math.cos(particle.direction) * 0.1 - 1;
            particle.rotation += Math.sin(particle.direction) * (particle.speed * particle.scale.y) * 0.05;
            // particle.rotation = -particle.direction + Math.PI;

            // opacity
            if(particle.alpha > 0.99) {
              alphaflags[i] = 1;
            } else if(particle.alpha < 0.05) {
              alphaflags[i] = 0;
            }
            if(alphaflags[i] == 1) {
              particle.alpha -= 0.001 * particle.speed;
            } else if (alphaflags[i] == 0 || alphaflags[i] == 2){
              particle.alpha += 0.001 * particle.speed;
            }
            // overflow
            if (particle.x < particleBounds.x) {
                particle.x += particleBounds.width;
            } else if (particle.x > particleBounds.x + particleBounds.width) {
                particle.x -= particleBounds.width;
            }

            if (particle.y < particleBounds.y) {
                particle.y += particleBounds.height;
            } else if (particle.y > particleBounds.y + particleBounds.height) {
                particle.y -= particleBounds.height;
            }
            // mouse
            if (mouse.x - particle.x < 50 && mouse.x - particle.x > -50 && mouse.y - particle.y < 50 && mouse.y - particle.y > -50) {
              particle.x += (mouse.x - particle.x) * particle.speed * 0.01;
              particle.y += (mouse.y - particle.y) * particle.speed * 0.01;
            }
        }
        tick += 0.1;
    });

    $(window).on("load resize", function () {
      app.renderer.resize(window.innerWidth, window.innerHeight);
      particleBounds.width = app.screen.width + particleBoundsPadding * 2;
      particleBounds.height = app.screen.height + particleBoundsPadding * 2;
    });
    $(window).on("scroll", function() {
    let scrollHeight = $(this).scrollTop();
      for (let i = 0; i < particles.length; i++) {
          const particle = particles[i];
          if(scrollHeight > beforePos) {
            particle.y -= 6 * particle.scale.y;
          } else {
            particle.y += 6 * particle.scale.y;
          }
      }
      beforePos = scrollHeight;
    });
  }
  if (/iPad|Macintosh/i.test(navigator.userAgent)&& 'ontouchend' in document){
  } else {
    // animParticles('particles','/6th/assets/images/common/common/bg_particle.png');
    if($('#particles-load').length){
      animParticles('particles-load','./assets/images/common/common/bg_particle.png');
    };
  }
};



// ------------------------------------------------------------------------
// resizeFv
// ----- BOTH
// ------------------------------------------------------------------------
const resizeFv = () => {
  $(window).on('resize load', function() {
    if (matchMedia('(max-width: 798px)').matches) {
      let dispWdt = window.innerWidth * 1.7;
      let dispHgt = window.innerHeight;
      if(dispHgt < dispWdt) {
        $(".st-Firstview").addClass("resize");
        $(".st-Firstview .chara").addClass("resize");
        $(".st-Firstview .logo").addClass("resize");
        $(".st-Firstview .movie-wrapper").addClass("resize");
        $(".st-Firstview .button").addClass("resize");
      } else {
        $(".st-Firstview").removeClass("resize");
        $(".st-Firstview .chara").removeClass("resize");
        $(".st-Firstview .logo").removeClass("resize");
        $(".st-Firstview .movie-wrapper").removeClass("resize");
        $(".st-Firstview .button").removeClass("resize");
      }
    } else {
      let dispWdt = window.innerWidth * (8/16);
      let dispHgt = window.innerHeight;
      if(dispHgt < dispWdt) {
        $(".st-Firstview .chara").addClass("resize");
        $(".st-Firstview .logo").addClass("resize");
        $(".st-Firstview .movie-wrapper").addClass("resize");
        $(".st-Firstview .button").addClass("resize");
      } else {
        $(".st-Firstview .chara").removeClass("resize");
        $(".st-Firstview .logo").removeClass("resize");
        $(".st-Firstview .movie-wrapper").removeClass("resize");
        $(".st-Firstview .button").removeClass("resize");
      }
    }
  });
};



export {
  tabletFlag,
  anchorLink,
  toggleMenu,
  mvSlider,
  loadingClose,
  loadingCloseAnv,
  msgStory,
  paraStory,
  paraNormal,
  letterSplit,
  scrollAnim,
  loadAnim,
  animParticle,
  preImage,
  moviePlay,
  resizeFv
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js